module.exports = __webpack_public_path__ + "static/img/ML.6855cd72.png";